module.exports = __webpack_public_path__ + "img/peerpal-gravyty-logo-white.fb379b75.svg";